function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

// load polyfills early
import pageInitializer from '../../lib/client/page-initializer';
import About from './about.jsx';
import { AppContext } from '../common/app-context.js';
import AppDetailsSection from './app-details.jsx';
import analytics from '../../lib/shared/analytics';
import autoBind from 'react-autobind';
import { Button, Loading, Modal, Tabs, TabList, Tab, TabPanels, TabPanel } from '@carbon/react';
import { Banner } from '@console/cloud-pal-community/components/Basic';
import { WarningAlt } from '@carbon/react/icons';
import capabilitiesModel from '../common/model/capability';
import client from '../../lib/shared/client';
import commonMsgs from '../../nls/common.properties';
import config from '../../lib/shared/config';
import constants from '../../lib/shared/constants';
import timeUtil from '../../lib/shared/time.js';
import DeployButtons from './deploy-buttons.jsx';
import DeployHeader from './deploy-header.jsx';
import ErrorSection from './error-section.jsx';
import EventEmitter from 'events';
import Log from '../../lib/client/setup/log';
import msgs from '../../nls/setup/deploy/deploy.properties';
import { isComplianceIntegrationTemplate, isComplianceIntegrationTemplateForIaC, isComplianceDeploymentTemplate, isContinuousComplianceTemplate, isComplianceTemplate, isPublicTemplate, mixinDynamicByocParams } from '../common/model/utils';
import Markdown from '../common/markdown.jsx';
import modal from '../../lib/client/modal';
import Notification from '../common/notification.jsx';
import Phase from '../common/model/phase';
import _Promise from 'bluebird';
import { Provider as CpcProvider } from '@console/cloud-pal-community/components/Basic';
import React from 'react';
import sessionUtil from '../../lib/shared/sessionUtil';
import TemplateLoader from '../common/model/template-loader';
import URITemplate from '../../lib/shared/uritemplate';
import urls from '../../lib/shared/urls';
import ToolchainCreateClient from '../common/model/toolchain-create-client';
import ValidationTracker from '../common/model/validation-tracker';
import vaultUtil from '../../lib/client/vault-util';
import WizardToolsPanel from './wizard-tools-panel.jsx';
import xhrPromise from '../../lib/client/xhr-promise';
import htmlUtil from '../../lib/shared/html-util';
import '../../scss/setup/deploy/deploy.scss';
var templateLogger = Log.getLogger("template");
var logger = Log.getLogger("deploy-page");
var MARKETING_TAGS = ["cm_mmc", "cm_sp", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
var VALIDATE_TIMEOUT = 10000; // 10 seconds
var resourceGroupTemplate = new URITemplate("{+context}/setup/api/v2/resource_groups?account_context={account_context}&bss_account={bss_account}");
var Deploy = /*#__PURE__*/function (_React$Component) {
  function Deploy(props) {
    var _this;
    _classCallCheck(this, Deploy);
    _this = _callSuper(this, Deploy, [props]);

    // We re-use this initial state during source provider switch
    _this.initialTemplateState = {
      capabilities: null,
      createClicked: false,
      enableCreateButton: false,
      expandedServiceType: null,
      integrationsAuthDone: false,
      isValid: {
        gitAccept: false,
        tcName: false,
        welcomeStep: false
      },
      loadError: null,
      overrideScroll: undefined,
      shouldFocus: undefined,
      showDetails: false
    };
    _this.state = _objectSpread(_objectSpread({
      account: null,
      allowedRegion: true,
      catalogMap: null,
      enableYmlPreprocessor: props.context.enableYmlPreprocessor,
      expandLabel: msgs.get("expandable.label.expand"),
      isIBMer: false,
      isDirty: false,
      isSessionExpired: false,
      phase: Phase.LOADING,
      resourceGroup: {},
      resourceGroups: [],
      resourceGroupsStatus: {
        loading: false,
        loaded: false
      },
      tabIndex: 0,
      template: {
        template: {},
        toolchain: {},
        services: {}
      },
      wizardCompletedStep: 0
    }, _this.initialTemplateState), {}, {
      isHydrated: false
    });
    var user = _this.props.context.user;
    if (user) {
      // Logged in user must wait for header
      _this.headerReadyPromise = new _Promise(function (resolve) {
        return _this.headerReady = resolve;
      }); // expose resolver
      _this.loggedIn = true;
      _this.state.isIBMer = _this.checkIsIBMer(user);
    } else {
      _this.headerReadyPromise = _Promise.resolve();
      _this.loggedIn = false;
    }
    _this.headerResolved = false;
    _this.timestamp = toTimestamp(new Date());
    _this.validatorEventEmitter = new EventEmitter();
    _this.tracker = new ValidationTracker(_this.validatorEventEmitter);
    autoBind(_this);
    return _this;
  }
  _inherits(Deploy, _React$Component);
  return _createClass(Deploy, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      _Promise.resolve().then(function () {
        return _this2.loadTemplate(_this2.headerReadyPromise);
      });
      var showDeprecationNotif = false;
      var formattedDate;

      // show banner after deprecation announcements date in applicable regions
      if (config.REGION_DEPRECATED === 'true' && timeUtil.isTodayAfter(config.REGION_DEPRECATED_AFTER_DATE)) {
        showDeprecationNotif = true;
        var announceDate = new Date(config.REGION_DEPRECATED_DISPLAY_DATE);
        var localeObj = {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        };

        // format date in locale, or fall back to en
        try {
          formattedDate = announceDate.toLocaleDateString(this.props.context.locale, localeObj);
        } catch (_unused) {
          formattedDate = announceDate.toLocaleDateString('en', localeObj);
        }
      }
      this.setState({
        isMounted: true,
        shouldFocus: false,
        showDeprecationNotif: showDeprecationNotif,
        isHydrated: true,
        deprecationNotifDate: formattedDate
      });

      // listen for account load/changes
      header.whenAccountReady(this.handleAccountReady);
      document.addEventListener('acctChanged', function (evt) {
        _this2.handleAccountChange({
          account: evt.detail.accountData.account
        });
      });

      // Check session state on page load
      sessionUtil.checkSessionState(function (_ref) {
        var inactiveTimeout = _ref.inactiveTimeout,
          isExpired = _ref.isExpired;
        _this2.setState({
          isSessionExpired: isExpired
        });
        // Setup another session state check near the time session is due to expire
        _this2.createDelayedSessionCheck(inactiveTimeout);
      });

      // Ensure user does not lose changes
      window.onbeforeunload = function (event) {
        // Prevent "are you sure?" dialog if session has expired
        if (!_this2.state.isSessionExpired) {
          sessionUtil.onLeavePage(_this2.state.isDirty, event);
        }
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.onbeforeunload = null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;
      if (!document.getElementById("serviceNotSupported")) {
        if (this.state.unsupported && this.loggedIn && this.state.unsupported && this.state.unsupported.length) {
          this.renderNotSupportedWarningModal();
        }
      }
      if (!document.getElementById("serviceUnavailable")) {
        var showUnresolvedWarning = this.state.unresolved && this.loggedIn && this.state.unresolved.length > 0 ? true : false;
        showUnresolvedWarning ? this.renderServiceWarningModal(this.state.region ? this.state.region : null) : null;
      }
      if (this.props.context.enableRg && this.state.resourceGroup && this.state.resourceGroup.name && !this.state.enableCreateButton && this.state.isValid.tcName) {
        this.setState({
          enableCreateButton: true
        });
      }
      if (this.isWizardModeEnabled() && client && !this.state.resourceGroupsStatus.loading && !this.state.resourceGroupsStatus.loaded) {
        // In wizard mode we need to load the resource groups here
        this.setState({
          resourceGroupsStatus: {
            loading: true,
            loaded: false
          }
        });
        _Promise.try(function () {
          if (_this3.state.account) {
            var promisesArray = [];
            if (_this3.props.context.enableRg) {
              var resourceGroupURL = resourceGroupTemplate.expand({
                context: config.CONTEXT_PATH,
                bss_account: _this3.state.account.accountGuid,
                account_context: _this3.state.account.contextId
              });
              promisesArray.push(xhrPromise(resourceGroupURL, {
                dataType: "json"
              }));
            }
            return _Promise.all(promisesArray).then(function (resultsArray) {
              var resourceGroups = [];
              var selectedResourceGroup = {};
              if (resultsArray.length && resultsArray[0].body.resources.length) {
                resourceGroups = resultsArray[0].body.resources.sort(function (a, b) {
                  return a.name.toLocaleLowerCase().localeCompare(b.name.toLowerCase());
                });
              }
              var defaultResourceGroup = resourceGroups.find(function (rg) {
                return rg.id === window.localStorage['otc-ui.selected_rg'];
              });
              selectedResourceGroup = defaultResourceGroup || resourceGroups[0] || {};
              _this3.setState({
                resourceGroups: resourceGroups,
                resourceGroup: selectedResourceGroup,
                resourceGroupsStatus: {
                  loading: false,
                  loaded: true
                }
              }, function () {
                if (!_this3.headerResolved) {
                  _this3.headerResolved = true;
                  _this3.headerReady();
                }
              });
            });
          }
        }).catch(function (error) {
          _this3.setState({
            loadError: error,
            resourceGroupsStatus: {
              loading: false,
              loaded: false
            }
          });
          _this3.handleWizardWelcomeValid(false);
        });
      }
    }
  }, {
    key: "createDelayedSessionCheck",
    value: function createDelayedSessionCheck(timeout, oldTimeoutId) {
      var _this4 = this;
      if (oldTimeoutId) {
        // Clear the old timeout to avoid memory leak
        clearTimeout(oldTimeoutId);
      }

      // Re-check session state 30s before the session is due to expire
      var sessionCheckId = setTimeout(function () {
        sessionUtil.checkSessionState(function (_ref2) {
          var inactiveTimeout = _ref2.inactiveTimeout,
            isExpired = _ref2.isExpired;
          _this4.setState({
            isSessionExpired: isExpired
          });
          if (!isExpired) {
            // Re-call this same function with the new timeout found, if the session is still active
            _this4.createDelayedSessionCheck(inactiveTimeout, sessionCheckId);
          }
        });
      }, (timeout - 30) * 1000); // Deduct 30s and convert seconds to milliseconds
    }
  }, {
    key: "checkIsIBMer",
    value: function checkIsIBMer(user) {
      if (user !== null && user !== void 0 && user.user_name) {
        var ibmEmailRegex = /(\.|@)ibm.com$/;
        return ibmEmailRegex.test(user.user_name);
      }
      return false;
    }
  }, {
    key: "setDirtyFlag",
    value: function setDirtyFlag() {
      var _this$state = this.state,
        isDirty = _this$state.isDirty,
        phase = _this$state.phase;
      if (phase === Phase.READY && !isDirty) {
        this.setState({
          isDirty: true
        });
      }
    }
  }, {
    key: "getRegion",
    value: function getRegion(allRegions, envId) {
      if (allRegions) {
        return allRegions.find(function (i) {
          return i.id === envId || i.deployment_id === envId;
        });
      }
    }
  }, {
    key: "getToolchainRegions",
    value: function getToolchainRegions(allRegions) {
      if (allRegions) {
        return allRegions.filter(function (i) {
          return i.type.includes('toolchain');
        });
      }
    }
  }, {
    key: "reloadTemplate",
    value: function reloadTemplate(_ref3) {
      var pipelineType = _ref3.pipelineType,
        sourceProvider = _ref3.sourceProvider;
      // Dynamically reload the template with the chosen source provider
      this.loadTemplate(this.headerReadyPromise, {
        pipelineType: pipelineType,
        sourceProvider: sourceProvider
      });
    }
  }, {
    key: "loadRegions",
    value: function () {
      var _loadRegions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$props$params;
        var envId, showHidden, account, allRegions, optionalAccount, _yield$xhrPromise, body, localRegion, toolchainRegions, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (((_this$props$params = this.props.params) === null || _this$props$params === void 0 ? void 0 : _this$props$params.enableRegionSwitcher) === "true") {
                console.log("DEBUG: params: ".concat(JSON.stringify(this.props.params)));
              }
              envId = this.props.context.envId, showHidden = this.props.showHidden, account = this.state.account;
              _context.p = 1;
              // no bss_account for anonymous/not-logged-in/expired-session users
              optionalAccount = account ? "&bss_account=".concat(account.accountGuid) : '';
              _context.n = 2;
              return xhrPromise("".concat(config.CONTEXT_PATH, "/locations?env_id=").concat(envId).concat(optionalAccount), {
                dataType: 'json'
              });
            case 2:
              _yield$xhrPromise = _context.v;
              body = _yield$xhrPromise.body;
              allRegions = body;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
              allRegions = [];
            case 4:
              localRegion = this.getRegion(allRegions, envId);
              if (!localRegion) {
                // placeholder region when we can't get the current region for any reason
                if (allRegions.length) {
                  this.setState({
                    allowedRegion: false
                  });
                }
                localRegion = {
                  id: config.REGION_ID,
                  deployment_id: envId,
                  display_name: commonMsgs.get('notavailable'),
                  type: ['toolchain']
                };
                allRegions.push(localRegion);
              } else {
                this.setState({
                  allowedRegion: true
                });
              }
              toolchainRegions = this.getToolchainRegions(allRegions);
              this.setState({
                allRegions: allRegions,
                region: localRegion,
                regionsConf: showHidden ? allRegions : toolchainRegions
              });
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function loadRegions() {
        return _loadRegions.apply(this, arguments);
      }
      return loadRegions;
    }()
  }, {
    key: "getFSAccountDetails",
    value: function () {
      var _getFSAccountDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(accountData) {
        var accountGuid, accountTraits, _yield$xhrPromise2, _accountTraits, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              accountGuid = accountData.account.accountGuid;
              accountTraits = {};
              accountTraits.fs_ready = false;
              this.accountTraits = accountTraits;
              this.accountTraitsError = false;
              if (!(this.props.context.enableFSCloudDialog === true)) {
                _context2.n = 4;
                break;
              }
              _context2.p = 1;
              _context2.n = 2;
              return xhrPromise("/api/v6/getAccountTraits?accountGuid=".concat(accountGuid), {
                dataType: 'json'
              });
            case 2:
              _yield$xhrPromise2 = _context2.v;
              _accountTraits = _yield$xhrPromise2.body;
              if ((_accountTraits === null || _accountTraits === void 0 ? void 0 : _accountTraits.fs_ready) !== true && (_accountTraits === null || _accountTraits === void 0 ? void 0 : _accountTraits.fs_ready) !== false) {
                this.accountTraitsError = true;
              } else {
                this.accountTraits = _accountTraits;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.accountTraitsError = true;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function getFSAccountDetails(_x) {
        return _getFSAccountDetails.apply(this, arguments);
      }
      return getFSAccountDetails;
    }()
  }, {
    key: "handleTabClick",
    value: function handleTabClick(index) {
      if (this.isWizardModeEnabled()) {
        this.setState({
          tabIndex: index
        });
      } else {
        this.setState({
          createClicked: false,
          tabIndex: index
        });
      }
    }
  }, {
    key: "setAuthDone",
    value: function setAuthDone(isDone) {
      if (this.isWizardModeEnabled()) {
        this.setState({
          integrationsAuthDone: isDone
        });
      } else {
        this.setState({
          integrationsAuthDone: isDone
        }, this.isDeployButtonEnabled(isDone));
      }
    }
  }, {
    key: "isDeployButtonEnabled",
    value: function isDeployButtonEnabled(enable) {
      if (!enable && !this.state.enableCreateButton) return; // trying to disable when already disabled.
      if (enable && this.state.enableCreateButton) return; // trying to enable when already enabled.
      var areUnresolvedCapabilities = false,
        isEnable = false;
      var integrationsAuthDone = this.state.integrationsAuthDone;
      // In case of empty toolchain
      if (this.getCapabilityCount() === 0) {
        integrationsAuthDone = true;
      }
      if (this.state.unresolved && this.state.unresolved.length > 0) {
        areUnresolvedCapabilities = true;
      }
      if (enable && integrationsAuthDone && this.state.phase !== Phase.PRE_CREATE && !!this.getToolchainName() && this.state.isValid.tcName && !areUnresolvedCapabilities) {
        isEnable = true;
      }
      this.setState({
        enableCreateButton: isEnable
      });
    }
  }, {
    key: "canCreateToolchain",
    value: function canCreateToolchain(permission) {
      this.setState({
        enableToolchainCreateButton: permission
      });
    }
  }, {
    key: "handleWizardWelcomeValid",
    value: function handleWizardWelcomeValid(enable) {
      if (!enable && !this.state.isValid.welcomeStep) return; // trying to disable when already disabled.
      if (enable && this.state.isValid.welcomeStep) return; // trying to enable when already enabled.
      var isWelcomeValid = false;
      if (enable && this.state.phase !== Phase.PRE_CREATE && !!this.getToolchainName() && this.state.isValid.tcName) {
        isWelcomeValid = true;
      }
      var newIsValid = Object.assign({}, this.state.isValid);
      newIsValid.welcomeStep = isWelcomeValid;
      this.setState({
        isValid: newIsValid
      });
    }
  }, {
    key: "handleGitAcceptValid",
    value: function handleGitAcceptValid(enable) {
      if (!enable && !this.state.isValid.gitAccept) return; // trying to disable when already disabled.
      if (enable && this.state.isValid.gitAccept) return; // trying to enable when already enabled.
      var isGitValid = false;
      var wizard = this.state.capabilities.getWizard();
      if (enable && this.state.phase !== Phase.PRE_CREATE && wizard !== null && wizard !== void 0 && wizard.showGitAccept()) {
        isGitValid = true;
      }
      var newIsValid = Object.assign({}, this.state.isValid);
      newIsValid.gitAccept = isGitValid;
      this.setState({
        isValid: newIsValid
      });
    }
  }, {
    key: "setNameValidity",
    value: function setNameValidity(validity, callback) {
      var newIsValid = Object.assign({}, this.state.isValid);
      newIsValid.tcName = validity;
      if (this.isWizardModeEnabled()) {
        this.setState({
          isValid: newIsValid
        }, callback);
      } else {
        this.setState({
          isValid: newIsValid
        }, callback);
      }
    }
  }, {
    key: "getCapabilityCount",
    value: function getCapabilityCount() {
      return this.state.capabilities && this.state.capabilities.types().length;
    }
  }, {
    key: "handleScrolled",
    value: function handleScrolled() {
      // Already scrolled to the expanded service, so restore the default scroll behavior
      this.setState({
        overrideScroll: undefined
      });
    }
  }, {
    key: "updateFocus",
    value: function updateFocus(value) {
      this.setState({
        shouldFocus: value
      });
    }

    // @returns true if every required service is configured, otherwise false and reveals the
    // unconfigured one
  }, {
    key: "checkConfigured",
    value: function checkConfigured() {
      var serviceTypesNeedingConfig;
      if (this.isWizardModeEnabled()) {
        serviceTypesNeedingConfig = Object.keys(this.state.capabilities.getWizardConfigRecommended());
      } else {
        serviceTypesNeedingConfig = Object.keys(this.state.capabilities.getConfigRecommended());
      }
      if (!serviceTypesNeedingConfig.length) {
        return true;
      }
      if (!this.isWizardModeEnabled()) {
        // Force user to deal with the service by expanding & scrolling it into view
        this.setState({
          expandedServiceType: serviceTypesNeedingConfig[0],
          overrideScroll: true,
          shouldFocus: true
        });
      } else {
        var wizard = this.state.capabilities.getWizard();
        if (!this.state.isValid.welcomeStep || wizard.showGitAccept() && !this.state.isValid.gitAccept) {
          // Go to step with toolchainName data if it is invalid
          var toolchainNameIndex = wizard.isV2() ? 1 : 0;
          this.handleTabClick(toolchainNameIndex);
          this.setWizardCompletedStep(toolchainNameIndex);
        } else {
          // Otherwise check the rest of the wizard steps for any that are invalid
          var invalidSteps = this.state.capabilities.getInvalidWizardSteps();
          var stepIndex = invalidSteps.length && wizard.getStepIndexByName(invalidSteps[0]);
          if (stepIndex >= 0) {
            // Add wizard offset to index to account for welcome step(s)
            this.handleTabClick(stepIndex + wizard.getWelcomeOffset());
            this.setWizardCompletedStep(stepIndex + wizard.getWelcomeOffset());
          }
        }
      }
      return false;
    }
  }, {
    key: "doCreate",
    value: function doCreate() {
      if (!this.checkConfigured()) {
        return;
      }
      this.createToolchain().spread(function (createdToolchainGuid, redirectUri) {
        logger.info("Created toolchain " + createdToolchainGuid);
        setTimeout(function () {
          return window.location = redirectUri;
        });
      }).catch(function (error) {
        logger.error(error);
        var message = error.message || error.body && error.body.description;
        if (!message) {
          message = "Unknown error";
        }
        if (!/nocreate/.test(message)) {
          analytics.track("create.toolchain.failed", {
            label: message,
            error: JSON.stringify(error)
          });
        }
      });
    }
  }, {
    key: "getTimeout",
    value: function getTimeout() {
      return window.testFlags && window.testFlags.validateTimeout || VALIDATE_TIMEOUT;
    }
  }, {
    key: "massValidate",
    value: function massValidate(validators) {
      validators.forEach(function (v) {
        logger.info("Calling validator", v.formValidator);
        v.validate();
      });
    }
  }, {
    key: "handleDeployClicked",
    value: function handleDeployClicked() {
      var _this5 = this;
      // let service tabs know when create is clicked so we can switch tabs only if the user is missing something after they click create
      this.setState({
        createClicked: true,
        isDirty: false
      });
      if (!this.checkConfigured()) {
        // We already know required services lack config, so don't bother continuing
        return;
      }
      if (this.isWizardModeEnabled()) {
        // Flip to the summary tab
        var wizard = this.state.capabilities.getWizard();
        var stepIndex = wizard.getStepCount({
          visibleOnly: true
        }) - 1;
        var welcomeOffset = wizard.getWelcomeOffset();
        this.setWizardCompletedStep(stepIndex + welcomeOffset);
        this.handleTabClick(stepIndex + welcomeOffset);
      }

      // Get validators, skipping those that are waiting for auth (they have no iframe, cannot do useful work)
      var tracker = this.tracker;
      var validators = tracker.validators().filter(function (validatorCtrl) {
        return !validatorCtrl.capabilityController.authorizationURI;
      });
      if (!validators.length) {
        this.doCreate();
        return;
      }
      // Enter the pre_create state -- in this state validators are given a chance to run.
      // Start mass validate, waiting for either all pending events to settle or 10s to elapse
      this.handlePhaseChange(Phase.PRE_CREATE);
      var listener;
      new _Promise(function (resolve) {
        listener = resolve;
        tracker.on("allSettled", listener);
      }).timeout(this.getTimeout()).then(function () {
        return logger.info("All settled; proceed to creation");
      }).catch(_Promise.TimeoutError, function () {
        // Timeout has elapsed. If we're waiting ONLY on validates, just go ahead and create.
        var importantWork = ["load", "unload", "populate", "authenticate"];
        if (importantWork.every(function (type) {
          return tracker.pending(type).length === 0;
        })) {
          var ids = tracker.allPending().map(function (v) {
            return v.id;
          }).join(", ");
          logger.info("Ignore pending events from " + ids + "; proceed to creation");
        } else {
          // Otherwise, keep waiting as important work still unfinished
          tracker.removeListener("allSettled", listener);
          return new _Promise(function (resolve) {
            listener = resolve;
            tracker.on("allSettled", listener);
          });
        }
      }).finally(function () {
        tracker.removeListener("allSettled", listener);
        _this5.handlePhaseChange(Phase.READY);
        _this5.doCreate();
      });
      this.massValidate(validators);
    }
  }, {
    key: "handleDetailsClicked",
    value: function handleDetailsClicked() {
      this.setState({
        showDetails: true
      });
    }
  }, {
    key: "handleDetailsCancel",
    value: function handleDetailsCancel() {
      this.setState({
        showDetails: false
      });
    }
  }, {
    key: "handleServiceClick",
    value: function handleServiceClick(type) {
      this.setState({
        expandedServiceType: type,
        shouldFocus: true
      });
    }

    // Evaluates certain "magic" template expressions such as {{timestamp}} that bypass the normal
    // template expansion algorithm.
    // @returns the value of the magic variable or `null` if variable is not magic.
  }, {
    key: "expandMagicVariable",
    value: function expandMagicVariable(variable) {
      var expr = variable.expression;
      if (expr === "timestamp") {
        return this.timestamp;
      } else if (expr === "region") {
        return this.state.region && this.state.region.id;
      }
      var params = this.props.params;
      if (params[expr] !== undefined) {
        return params[expr];
      }
      // if branch param is not specified, use master branch
      if (expr === 'branch') {
        return 'master';
      }
      return null;
    }
  }, {
    key: "isWizardModeEnabled",
    value: function isWizardModeEnabled() {
      var _this$state$capabilit, _this$state$capabilit2;
      return !!(this.props.context.enableSetupWizard && ((_this$state$capabilit = this.state.capabilities) === null || _this$state$capabilit === void 0 || (_this$state$capabilit = _this$state$capabilit.templateData) === null || _this$state$capabilit === void 0 ? void 0 : _this$state$capabilit.version) === "3" && (_this$state$capabilit2 = this.state.capabilities) !== null && _this$state$capabilit2 !== void 0 && (_this$state$capabilit2 = _this$state$capabilit2.templateData) !== null && _this$state$capabilit2 !== void 0 && (_this$state$capabilit2 = _this$state$capabilit2.template) !== null && _this$state$capabilit2 !== void 0 && _this$state$capabilit2.wizard);
    }
  }, {
    key: "setWizardCompletedStep",
    value: function setWizardCompletedStep(index) {
      this.setState({
        wizardCompletedStep: index
      });
    }
  }, {
    key: "getToolchainUrl",
    value: function getToolchainUrl(guid, envId) {
      var params = this.props.params;
      var splitRegion = params['k8s-region'] && params['k8s-region'].split(':');
      var iksParams = _objectSpread(_objectSpread({}, params), {}, {
        region: splitRegion && splitRegion.length === 3 ? splitRegion[2] : params['k8s-region'],
        'resource-group': params['resource-group-id'],
        'nav-mode': params['k8s-cluster-name'] && params['k8s-cluster-id'] && params['k8s-region'] && params['resource-group-id'] ? 'iks' : undefined
      });
      if (!guid) {
        return null;
      }
      var template = new URITemplate(window.location.protocol + "//" + window.location.host + "/devops/toolchains/{guid}");
      var url = template.expand({
        guid: guid
      });
      // add the env_id this way to avoid encoding the ':' in the env_id, which the reverse proxy doesn't expect
      // and makes the URLs ugly.
      url = envId ? urls.addUrlParam(url, 'env_id', envId) : url;
      if (iksParams['nav-mode'] === 'iks' && iksParams['k8s-cluster-name'] && iksParams['k8s-cluster-id'] && iksParams['region'] && iksParams['resource-group']) {
        url = "".concat(url).concat(url.includes('?') ? '&' : '?', "nav-mode=iks&k8s-cluster-name=").concat(encodeURIComponent(iksParams['k8s-cluster-name']), "&k8s-cluster-id=").concat(encodeURIComponent(iksParams['k8s-cluster-id']), "&region=").concat(encodeURIComponent(iksParams['region']), "&resource-group=").concat(encodeURIComponent(iksParams['resource-group']));
      }
      return url;
    }
  }, {
    key: "getToolchainName",
    value: function getToolchainName() {
      var toolchain = this.state.capabilities && this.state.capabilities.getToolchain();
      return toolchain && toolchain.name;
    }

    // Callback descendant components use to set the phase toolchain creation is in
  }, {
    key: "handlePhaseChange",
    value: function handlePhaseChange(phase) {
      this.setState({
        phase: phase
      });
    }
  }, {
    key: "updateRepositoryUrl",
    value: function updateRepositoryUrl(repoUrl, selectedRegion) {
      // Special case handling for changing region when source repo has .git.cloud.ibm.com/open-toolchain
      // Replace the region specific details with the new region & expect to handle special case for eu-fr2
      // Remove the "private" prefix from eu-fr2 region before switching the region
      var repository_url = repoUrl.replace("private.eu-fr2", "eu-fr2");
      repository_url = repository_url.replace(this.state.region.id, selectedRegion.id);
      // Re-add the "private." prefix to eu-fr2 region
      if (repository_url.toLowerCase().indexOf("eu-fr2") > -1 && repository_url.toLowerCase().indexOf("private.eu-fr2") === -1) {
        repository_url = repository_url.replace("eu-fr2", "private.eu-fr2");
      }
      return repository_url;
    }
  }, {
    key: "handleComponentRegionChange",
    value: function handleComponentRegionChange(selectedRegion) {
      // check for region change
      if (selectedRegion && selectedRegion.id !== (this.state.region && this.state.region.id)) {
        var _this$props$params2;
        var useNewRegionSwitcher = ((_this$props$params2 = this.props.params) === null || _this$props$params2 === void 0 ? void 0 : _this$props$params2.enableRegionSwitcher) === "true";
        if (useNewRegionSwitcher && this.isWizardModeEnabled()) {
          console.log("DEBUG: state.region: ".concat(JSON.stringify(this.state.region)));
          console.log("DEBUG: state.allRegions: ".concat(JSON.stringify(this.state.allRegions)));
          console.log("DEBUG: selectedRegion: ".concat(JSON.stringify(selectedRegion)));
          var searchParams = new URLSearchParams(window.location.search);
          var repoParam = searchParams.get("repository");
          console.log("DEBUG: repoParam: ".concat(JSON.stringify(repoParam)));
          searchParams.set("env_id", selectedRegion.deployment_id);
          if ((repoParam === null || repoParam === void 0 ? void 0 : repoParam.toLowerCase().indexOf(".git.cloud.ibm.com/open-toolchain/")) > -1) {
            var newRepoUrl = this.updateRepositoryUrl(repoParam, selectedRegion);
            console.log("DEBUG: newRepoUrl: ".concat(JSON.stringify(newRepoUrl)));
            searchParams.set("repository", newRepoUrl);
          }
          if (history.pushState) {
            var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(searchParams.toString());
            console.log("DEBUG: newurl: ".concat(JSON.stringify(newurl)));
            window.history.pushState({
              path: newurl
            }, "", newurl);
            // this.reloadTemplate({ env_id: selectedRegion.deployment_id });
            this.loadRegions();
          }
          return;
        } else {
          // until we support global console, redirect to the new ?env_id to load the UI from the other region
          var params = urls.params(location.href);
          delete params.env_id;
          if (params.repository && params.repository[0] && params.repository[0].toLowerCase().indexOf(".git.cloud.ibm.com/open-toolchain/") > -1) {
            params.repository[0] = this.updateRepositoryUrl(params.repository[0], selectedRegion);
          }
          var search = urls.objToQueryString(params);
          location.replace(location.pathname + search + (search ? '&' : '?') + 'env_id=' + selectedRegion.deployment_id);
          return;
        }
      }
    }
  }, {
    key: "handleComponentRGChange",
    value: function handleComponentRGChange(selectedRG, callback) {
      var _this6 = this;
      this.setState({
        resourceGroup: selectedRG
      }, function () {
        if (!_this6.headerResolved) {
          _this6.headerResolved = true;
          _this6.headerReady();
        }
        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: "handleClearRG",
    value: function handleClearRG(callback) {
      this.setState({
        resourceGroup: {}
      }, callback);
    }

    // Called to handle dismissal of the creation error dialog
  }, {
    key: "handleCreateErrorModalClose",
    value: function handleCreateErrorModalClose() {
      this.setState({
        createError: null
      });
      // model.error(null);
      // this.forceUpdate();
    }
  }, {
    key: "handleValidatorEvent",
    value: function handleValidatorEvent(type, event) {
      this.validatorEventEmitter.emit(type, event);
    }
  }, {
    key: "checkFSCloudCompliant",
    value: function checkFSCloudCompliant() {
      var isFSCompliant = true;
      var allTools = this.state.capabilities && this.state.capabilities.types({
        excludeWizardForms: true
      }) || [];
      var _iterator = _createForOfIteratorHelper(allTools),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _toolCapabilities$;
          var tool = _step.value;
          var toolCapabilities = this.state.capabilities.getByType(tool);
          if ((_toolCapabilities$ = toolCapabilities[0]) !== null && _toolCapabilities$ !== void 0 && (_toolCapabilities$ = _toolCapabilities$.service) !== null && _toolCapabilities$ !== void 0 && _toolCapabilities$.tags) {
            var tags = toolCapabilities[0].service.tags;
            if (!tags.includes(constants.fsCloudTag)) {
              isFSCompliant = false;
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return isFSCompliant;
    }
  }, {
    key: "findFirstMatch",
    value: function findFirstMatch(regExInfoObject, newValue) {
      var regExInfos = [];
      for (var key in regExInfoObject) {
        if (regExInfoObject.hasOwnProperty(key)) {
          regExInfos.push(regExInfoObject[key]);
        }
      }
      var namedGroupsSupported = false;
      try {
        new RegExp('(?<name>a)');
        namedGroupsSupported = true;
      } catch (e) {
        // expected to occur in FireFox
      }
      if (namedGroupsSupported) {
        for (var i = 0; i < regExInfos.length; i++) {
          var info = regExInfos[i];
          var re = new RegExp(info.template, info.flags);
          var regExRes = re && re.exec(newValue);
          if (regExRes) {
            return regExRes;
          }
        }
        return;
      }
      // The regex groups in secrets-client are all simple, like (?<reference>
      var namedGroupStart = /\(\?\<([a-z]+)\>/g;
      var _loop = function _loop() {
          var info = regExInfos[_i];
          var origTemplate = info.template;
          var simpleTemplate = origTemplate.replace(namedGroupStart, '(');
          var re = new RegExp(simpleTemplate, info.flags);
          var regExRes = re && re.exec(newValue);
          if (regExRes) {
            regExRes.groups = {};
            var index = 1;
            // iterate through group names
            origTemplate.replace(namedGroupStart, function (match, groupName) {
              var groupValue = regExRes[index];
              regExRes.groups[groupName] = groupValue;
              index += 1;
            });
            return {
              v: regExRes
            };
          }
        },
        _ret;
      for (var _i = 0; _i < regExInfos.length; _i++) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }
    }
  }, {
    key: "handleDetectSecretReference",
    value: function handleDetectSecretReference(newValue, next) {
      // Check feature flag and regEx existence
      var context = this.props.context;
      if (!(context && context.enableSecretDtc && context.secretRegExs && context.envId)) {
        return next(newValue);
      }

      // find out if it's a valid vault::, kp::, or hv:: reference...
      var regExRes = this.findFirstMatch(context.secretRegExs, newValue);
      if (!regExRes) {
        return next(newValue);
      }

      // Get the reference instance details
      var refReference = newValue;
      var refProvider = regExRes.groups && regExRes.groups.provider;
      var refSecret = regExRes.groups && regExRes.groups.secret;
      var refSecretPath;
      var refFieldPath;
      var refDetails;
      if (refProvider && refSecret) {
        if (refProvider === vaultUtil.VTI_REFERENCE_TYPE) {
          var refIntegration = regExRes.groups.integration;
          var refSecretParts = refSecret.split('.');
          refDetails = {
            integrationName: refIntegration,
            secretName: refSecretParts[0],
            type: refProvider
          };
          refSecretPath = refSecretParts[0];
          var x = 1;
          if (refSecretParts.length > x) {
            if (!refSecretParts[x].includes("=")) {
              refFieldPath = refSecretParts[x];
              refDetails.field = refFieldPath;
              refSecretPath += "." + refFieldPath;
              ++x;
            }
            if (refSecretParts.length > x) {
              refSecretPath += "?";
              for (var _i2 = x; _i2 < refSecretParts.length; _i2++) {
                refSecretPath += refSecretParts[_i2];
                if (_i2 < refSecretParts.length - 1) {
                  refSecretPath += ".";
                }
                var _embeddedOp = refSecretParts[_i2];
                if (_embeddedOp) {
                  if (_embeddedOp.startsWith("format=")) {
                    refDetails.format = _embeddedOp;
                  } else if (_embeddedOp.startsWith("default=")) {
                    refDetails.default = _embeddedOp;
                  } else if (_embeddedOp.startsWith("version=")) {
                    refDetails.version = _embeddedOp;
                  }
                }
              }
            }
          }
        } else if (refProvider === vaultUtil.KP_REFERENCE_TYPE) {
          var _refSecretParts = refSecret.split('.');
          refDetails = {
            region: context.envId.slice(0, context.envId.lastIndexOf(':') + 1) + _refSecretParts[0],
            resourceGroup: _refSecretParts[1],
            instanceName: _refSecretParts[2],
            keyName: _refSecretParts[3],
            type: refProvider
          };
          refSecretPath = _refSecretParts[3];
          var _x2 = 4;
          if (_refSecretParts.length > _x2) {
            if (!_refSecretParts[_x2].includes("=")) {
              refFieldPath = _refSecretParts[_x2];
              refDetails.field = refFieldPath;
              refSecretPath += "." + refFieldPath;
              ++_x2;
            }
            if (_refSecretParts.length > _x2) {
              refSecretPath += "?";
              for (var _i3 = _x2; _i3 < _refSecretParts.length; _i3++) {
                refSecretPath += _refSecretParts[_i3];
                if (_i3 < _refSecretParts.length - 1) {
                  refSecretPath += ".";
                }
                var _embeddedOp2 = _refSecretParts[_i3];
                if (_embeddedOp2) {
                  if (_embeddedOp2.startsWith("format=")) {
                    refDetails.format = _embeddedOp2;
                  } else if (_embeddedOp2.startsWith("default=")) {
                    refDetails.default = _embeddedOp2;
                  }
                }
              }
            }
          }
        } else if (refProvider === vaultUtil.SM_REFERENCE_TYPE) {
          var _refSecretParts2 = refSecret.split('.');
          refDetails = {
            region: context.envId.slice(0, context.envId.lastIndexOf(':') + 1) + _refSecretParts2[0],
            resourceGroup: _refSecretParts2[1],
            instanceName: _refSecretParts2[2],
            groupName: _refSecretParts2[3],
            secretName: _refSecretParts2[4],
            keyName: _refSecretParts2[5],
            type: refProvider
          };
          refSecretPath = "".concat(refDetails.groupName, ".").concat(refDetails.secretName) + (refDetails.keyName ? ".".concat(refDetails.keyName) : "");
        } else if (refProvider === vaultUtil.HV_REFERENCE_TYPE) {
          var refConnection = regExRes.groups.connection;
          var refConnectionParts = refConnection && refConnection.split('|');
          var _refSecretParts3 = refSecret.split('.');
          refDetails = {
            secretName: refSecret,
            type: refProvider
          };
          var refServerUrl = refConnectionParts[0];
          var refDashboardUrl;
          var refAuthenticationMethod;
          if (refConnectionParts[1] === "approle" || refConnectionParts[1] === "token") {
            refDashboardUrl = refServerUrl + "/ui";
            refAuthenticationMethod = refConnectionParts[1];
            if (refAuthenticationMethod === "token") {
              refDetails.token = refConnectionParts[2];
            } else if (refAuthenticationMethod === "approle") {
              refDetails.role_id = refConnectionParts[2];
              refDetails.secret_id = refConnectionParts[3];
            }
          } else {
            refDashboardUrl = refConnectionParts[1];
            refAuthenticationMethod = refConnectionParts[2];
            if (refAuthenticationMethod === "token") {
              refDetails.token = refConnectionParts[3];
            } else if (refAuthenticationMethod === "approle") {
              refDetails.role_id = refConnectionParts[3];
              refDetails.secret_id = refConnectionParts[4];
            }
          }
          refDetails.server_url = refServerUrl;
          refDetails.dashboard_url = refDashboardUrl;
          refDetails.authentication_method = refAuthenticationMethod;
          refSecretPath = _refSecretParts3[0];
          var _x3 = 1;
          if (_refSecretParts3.length > _x3) {
            if (!_refSecretParts3[_x3].includes("=")) {
              refFieldPath = _refSecretParts3[_x3];
              refDetails.field = refFieldPath;
              refSecretPath += "." + refFieldPath;
              ++_x3;
            }
            if (_refSecretParts3.length > _x3) {
              refSecretPath += "?";
              for (var _i4 = _x3; _i4 < _refSecretParts3.length; _i4++) {
                refSecretPath += _refSecretParts3[_i4];
                if (_i4 < _refSecretParts3.length - 1) {
                  refSecretPath += ".";
                }
                var _embeddedOp3 = _refSecretParts3[_i4];
                if (_embeddedOp3) {
                  if (_embeddedOp3.startsWith("format=")) {
                    refDetails.format = _embeddedOp3;
                  } else if (_embeddedOp3.startsWith("default=")) {
                    refDetails.default = _embeddedOp3;
                  } else if (_embeddedOp3.startsWith("version=")) {
                    refDetails.version = _embeddedOp3;
                  }
                }
              }
            }
          }
        }
      } else {
        return next(refReference);
      }

      // Fetch all existing toolintegrations
      var templateServices = this.state.capabilities && this.state.capabilities.getTopLevelData() && this.state.capabilities.getTopLevelData().services;
      var vaultIntegrations = vaultUtil.getVaultIntegrations(templateServices);

      // Search for the instance in the existing integrations
      var integration;
      if (refProvider === vaultUtil.VTI_REFERENCE_TYPE) {
        integration = vaultIntegrations.find(function (vi) {
          return refDetails.integrationName === vi.name;
        });
      } else if ([vaultUtil.KP_REFERENCE_TYPE, vaultUtil.SM_REFERENCE_TYPE].includes(refProvider)) {
        integration = vaultIntegrations.find(function (vi) {
          var _refDetails$region, _vi$region;
          return refDetails.instanceName === vi.instanceName &&
          // Use short form region for comparison
          ((_refDetails$region = refDetails.region) === null || _refDetails$region === void 0 ? void 0 : _refDetails$region.split(':').pop()) === ((_vi$region = vi.region) === null || _vi$region === void 0 ? void 0 : _vi$region.split(':').pop()) && refDetails.resourceGroup === vi.resourceGroup && refDetails.type === vi.type &&
          // Don't include SM CRN integs in the check
          vi.instanceIdType !== 'instance-crn';
        });
      } else if (refProvider === vaultUtil.HV_REFERENCE_TYPE) {
        integration = vaultIntegrations.find(function (vi) {
          return refDetails.server_url === vi.server_url && refDetails.authentication_method === vi.authentication_method && refDetails.type === vi.type;
        });
      }
      if (integration) {
        // Vault integration already exists for this secret
        if (refProvider === vaultUtil.VTI_REFERENCE_TYPE) {
          return next(refReference);
        } else {
          return next("{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(integration.name, ".").concat(refSecretPath, "}"));
        }
      } else {
        // restrict injection of integrations to kp or hv...
        if (refProvider === vaultUtil.VTI_REFERENCE_TYPE) {
          return next(refReference);
        }
      }
      var newIntegrationName;
      if (refProvider !== vaultUtil.VTI_REFERENCE_TYPE) {
        // We need to create a new integration
        // Find a unique name
        var i = 1;
        var newIntegrationNamePrefix;
        switch (refProvider) {
          case vaultUtil.KP_REFERENCE_TYPE:
            newIntegrationNamePrefix = "ibm-keyprotect-secrets";
            break;
          case vaultUtil.SM_REFERENCE_TYPE:
            newIntegrationNamePrefix = "ibm-secrets-manager-secrets";
            break;
          default:
            newIntegrationNamePrefix = "hashicorp-vault-secrets";
            break;
        }
        while (true) {
          newIntegrationName = "".concat(newIntegrationNamePrefix, "-").concat(i);
          if (!vaultIntegrations.find(function (vi) {
            return vi.name === newIntegrationName;
          })) {
            break;
          }
          i++;
        }
      } else {
        // use the name from the ref for the new integration...
        newIntegrationName = refDetails.integrationName;
      }

      // Create the integration
      var serviceName = "secrets-service-".concat(vaultIntegrations.length + 1);
      var newServiceTemplateFragment = {
        "template": {
          "required": [serviceName]
        },
        "services": {}
      };
      if (refProvider === vaultUtil.KP_REFERENCE_TYPE) {
        newServiceTemplateFragment.services[serviceName] = {
          "service_id": vaultUtil.KP_SERVICE_ID,
          "parameters": {
            "name": newIntegrationName,
            "region": refDetails.region,
            "resource-group": refDetails.resourceGroup,
            "instance-name": refDetails.instanceName,
            "type": refDetails.type
          }
        };
      } else if (refProvider === vaultUtil.SM_REFERENCE_TYPE) {
        newServiceTemplateFragment.services[serviceName] = {
          "service_id": vaultUtil.SM_SERVICE_ID,
          "parameters": {
            "name": newIntegrationName,
            "region": refDetails.region,
            "resource-group": refDetails.resourceGroup,
            "instance-name": refDetails.instanceName,
            "type": refDetails.type
          }
        };
      } else if (refProvider === vaultUtil.HV_REFERENCE_TYPE) {
        newServiceTemplateFragment.services[serviceName] = {
          "service_id": vaultUtil.HV_SERVICE_ID,
          "parameters": {
            "name": newIntegrationName,
            "server_url": refDetails.server_url,
            "dashboard_url": refDetails.dashboard_url,
            "authentication_method": refDetails.authentication_method,
            "type": refDetails.type
          }
        };
        if (refDetails.authentication_method === "token") {
          newServiceTemplateFragment.services[serviceName].parameters.token = refDetails.token;
        } else if (refDetails.authentication_method === "approle") {
          newServiceTemplateFragment.services[serviceName].parameters.role_id = refDetails.role_id;
          newServiceTemplateFragment.services[serviceName].parameters.secret_id = refDetails.secret_id;
        }
      }
      var catalogMap = this.state.catalogMap;
      TemplateLoader.tweakTemplate(newServiceTemplateFragment, catalogMap);
      var capabilities = this.state.capabilities;
      var originalTemplate = this.state.template;
      var unresolvedCapabilityIds = [];
      var unsupportedCapabilityIds = [];
      // was silently added when a field value changed, not initially present in template.
      var isSilentlyAdded = true;
      capabilitiesModel.addToCapabilitiesModel(originalTemplate, newServiceTemplateFragment, capabilities, unresolvedCapabilityIds, unsupportedCapabilityIds, isSilentlyAdded);
      var unresolved = [].concat(this.state.unresolved).concat(unresolvedCapabilityIds);
      var unsupported = [].concat(this.state.unsupported).concat(unsupportedCapabilityIds);
      this.setState({
        capabilities: capabilities,
        template: originalTemplate,
        unresolved: unresolved,
        unsupported: unsupported
      }, function () {
        next("{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(newIntegrationName, ".").concat(refSecretPath, "}"));
      });
    }
  }, {
    key: "isCapabilityHasSecretRef",
    value: function isCapabilityHasSecretRef(capability) {
      var _this7 = this;
      var context = this.props.context;
      if (!(context !== null && context !== void 0 && context.enableSecretPicker)) {
        return false;
      }
      if (!(capability.schema && capability.schema.properties) || !capability.parameters) {
        return false;
      }
      var isSecretRef = function isSecretRef(propValue) {
        // Note this code same as in deploy.jsx handleDetectSecretReference
        // find out if it's a valid vault::, kp::, or hv:: reference...
        var regExRes = _this7.findFirstMatch(context.secretRegExs, propValue);
        return !!regExRes;
      };
      var firstSecretRef = Object.keys(capability.parameters).find(function (propName) {
        if (!vaultUtil.isVaultProperty(propName, capability, _this7.props.context)) {
          return false;
        }
        var propValue = capability.parameters[propName];
        return isSecretRef(propValue);
      });
      return !!firstSecretRef;
    }
  }, {
    key: "loadTemplate",
    value: function loadTemplate(headerReadyPromise, overrides) {
      var _this8 = this;
      templateLogger.debug("Loading template");
      if (!!overrides) {
        // When reloading the template, override(s) are provided. First reset the template state before load
        var resetState = _objectSpread({}, this.initialTemplateState);
        resetState.template = {
          version: this.state.template.version,
          template: this.state.template.template
        };

        // Update capabilities model with reeset template
        var resetCapabailitiesModel = capabilitiesModel.buildCapabilitiesModel(resetState.template, this.state.catalogMap, {
          allowWizard: this.props.context.enableSetupWizard
        });
        resetState.capabilities = resetCapabailitiesModel.capabilities;
        if (this.isWizardModeEnabled()) {
          // In wizard mode need to clear the steps
          resetState.capabilities.getWizard().clearSteps();
        }
        new _Promise(function (resolve) {
          _this8.setState(_objectSpread({}, resetState), resolve);
        });
      }
      var params = this.props.params;
      var marketingTags = {};
      for (var _i5 = 0, _MARKETING_TAGS = MARKETING_TAGS; _i5 < _MARKETING_TAGS.length; _i5++) {
        var mt = _MARKETING_TAGS[_i5];
        if (params[mt]) {
          marketingTags[mt] = params[mt];
        }
      }
      return _Promise.try(function () {
        var options = {
          repositoryUrl: params.repository || null,
          branch: params.branch,
          /* || "master",*/
          repositoryToken: params.repository_token || null,
          type: params.type || null,
          zipUrl: params.zip_url || null,
          loggedIn: _this8.loggedIn,
          redirectUri: params.redirect_uri || null,
          marketingTags: marketingTags
        };
        if (overrides !== null && overrides !== void 0 && overrides.sourceProvider) {
          params.source_provider = overrides.sourceProvider;
        }
        if (overrides !== null && overrides !== void 0 && overrides.pipelineType) {
          params.pipeline_type = overrides.pipelineType;
        }
        mixinDynamicByocParams(options, _this8.props.context, params);
        options.allowWizard = _this8.props.context.enableSetupWizard;
        var loader = new TemplateLoader(options);
        loader.sendRequest();
        // Wait for headerReady because load needs state info set by header
        return headerReadyPromise.then(function () {
          var loadOptions = {
            loadEventName: _this8.state.loadEventName || null,
            accountRegion: _this8.state.accountRegion || null
          };
          return loader.load(loadOptions);
        });
      }).spread(function (template, source, capabilityInfo, catalogMap) {
        // Wait for state to update before continuing
        return new _Promise(function (resolve) {
          _this8.setState({
            template: template,
            source: source,
            capabilities: capabilityInfo.capabilities,
            unresolved: capabilityInfo.unresolved,
            unsupported: capabilityInfo.unsupported,
            marketingTags: marketingTags,
            catalogMap: catalogMap
          }, resolve);
        });
      }).then(function () {
        if (_this8.state.capabilities) {
          _this8.state.capabilities.setUpdateStateCallback(_this8.updateCapabilitiesState);
        }
        // Now this.state contains the template and capabilities
        var capabilities = _this8.state.capabilities;
        var unresolved = _this8.state.unresolved;
        var unsupported = _this8.state.unsupported;

        // Need to update templates twice to handle the toolchain name: it may or may not be
        // generated from a template.
        _this8.updateRefs();
        _this8.setToolchainName(getInitialToolchainName(capabilities), false);
        _this8.updateRefs();
        var prettyCap = JSON.parse(JSON.stringify(capabilities, function (k, v) {
          return k === "imageUrl" ? ".." : v;
        }, 2));
        templateLogger.log("Using capabilities model: ", prettyCap);
        if (_this8.loggedIn && unresolved.length) {
          templateLogger.warn("Schema could not be found for capabilities:", unresolved.join(", "));
        }
        if (_this8.loggedIn && unsupported.length) {
          templateLogger.warn("Capabilities that are not supported were found: ", unsupported.join(", "));
        }
      }).catch(function (error) {
        if (error.redirectToLogin) {
          location.href = "/login?state=".concat(encodeURIComponent(location.pathname + location.search));
        } else {
          headerReadyPromise.then(function () {
            _this8.setState({
              loadError: makeGoodError(error)
            });
          });
          templateLogger.error(error);
          var details = error.details;
          if (details) {
            templateLogger.error(details.message || details);
            if (details.input) {
              templateLogger.error("Input was: " + JSON.stringify(details.input, null, "\t"));
            }
          }
        }
      }).finally(function () {
        return _this8.handlePhaseChange(Phase.READY);
      });
    }
  }, {
    key: "updateCapabilitiesState",
    value: function updateCapabilitiesState(value) {
      if (value && value.capabilities) {
        var _capabilities = value.capabilities;
        var _template = this.state.template;
        _template.services = _capabilities.templateData && _capabilities.templateData.services;
        this.setState({
          capabilities: _capabilities,
          template: _template
        });
      }
    }

    // Callback used by child components (and this component) to update mustache references
    // after a change.
  }, {
    key: "updateRefs",
    value: function updateRefs() {
      var result = this.state.capabilities.updateAllRefs(this.expandMagicVariable.bind(this));
      var toolchain = this.state.capabilities.getToolchain();
      if (result.some(function (capability) {
        return capability === toolchain;
      })) {
        // Toolchain name may've changed in model which impacts child component ToolchainName.
        // So need to force update here
        this.forceUpdate();
      }
      return result;
    }
  }, {
    key: "resolveRef",
    value: function resolveRef(capability, paramPath) {
      var result = this.state.capabilities.resolveRef(this.expandMagicVariable.bind(this), capability, paramPath);
      return result;
    }
  }, {
    key: "setToolchainName",
    value: function setToolchainName(value, userEdit) {
      // Edit the name value within the capabilities model
      var toolchain = this.state.capabilities.getToolchain();
      if (toolchain) {
        toolchain.name = value;
        if (typeof userEdit === "undefined" || userEdit) {
          // This is a user change: delete any template it has
          this.state.capabilities.deleteTemplate(toolchain, "name", "toolchain");
        }
      }

      // Unfortunately since the name is managed within capabilities model and not directly
      // as React state, we need to force an update after changing it
      this.forceUpdate();
    }

    // @returns promise fulfilling to [guid, url]
  }, {
    key: "createToolchain",
    value: function createToolchain() {
      var _this9 = this;
      this.handlePhaseChange(Phase.CREATING);
      this.setState({
        createError: null
      });
      var _this$props = this.props,
        context = _this$props.context,
        params = _this$props.params;
      var options = {
        regionId: this.state.region ? this.state.region.id : null,
        resourceGroup: this.state.resourceGroup,
        capabilities: this.state.capabilities,
        name: this.getToolchainName(),
        nocreate: params.nocreate,
        repo: params.repository,
        template: this.state.template,
        source: this.state.source,
        marketingTags: this.state.marketingTags,
        enableRg: context.enableRg,
        appId: params.app_id,
        // devex app id
        appTenant: params.tenant
      };
      mixinDynamicByocParams(options, context, params);

      // Get secret feature flags
      options.enableSecretPicker = context && context.enableSecretPicker;
      options.enableSecretDtc = context && context.enableSecretDtc;
      return new ToolchainCreateClient(options).create().then(function (toolchainGuid) {
        _this9.handlePhaseChange(Phase.CREATED);
        var redirectUri = _this9.getToolchainUrl(toolchainGuid, context.envId);
        if (_this9.state.template.redirect_uri) {
          try {
            var url = new URL(_this9.state.template.redirect_uri);
            url.search += (url.search ? '&' : '?') + 'toolchain_url=' + encodeURIComponent(redirectUri);
            redirectUri = url.href;
          } catch (e) {
            logger.warn('illegal redirect_uri ' + _this9.state.template.redirect_uri);
          }
        }
        return [toolchainGuid, redirectUri];
      }).catch(function (error) {
        if (error.xhr && error.xhr.status === 401) {
          // Hack: session expired dialog is being shown. Don't change phase back to READY or
          // the re-render will hide the dialog
          logger.warn("Session expired");
          return;
        }
        _this9.handlePhaseChange(Phase.READY);
        if (!error.fake) {
          _this9.setState({
            createError: error
          });
        }
        throw error;
      });
    }
  }, {
    key: "handleAccountReady",
    value: function handleAccountReady(data) {
      this.setState({
        account: data.account
      });
      this.loadRegions();
      this.getFSAccountDetails(data);
      // note initial set of account will trigger load of resourceGroups,
      // and then call handleComponentRGChange
      if (client) {
        // add ?env_id of the selected location if not already in the URL
        // without reloading the page
        var envId = urls.param(location.href, 'env_id');
        if (!envId) {
          envId = this.props.context.envId;
          var newUrl = urls.addUrlParam(location.pathname + location.search, 'env_id', envId);
          history.replaceState({}, null, newUrl);
        }
      }
    }
  }, {
    key: "handleAccountChange",
    value: function handleAccountChange(data) {
      this.setState({
        account: data.account
      });
      this.loadRegions();
      this.getFSAccountDetails(data);
    }
  }, {
    key: "toggleExpandableTileText",
    value: function toggleExpandableTileText() {
      if (this.state.expandLabel === msgs.get("expandable.label.expand")) {
        this.setState({
          expandLabel: msgs.get("expandable.label.hide")
        });
      } else {
        this.setState({
          expandLabel: msgs.get("expandable.label.expand")
        });
      }
    }
  }, {
    key: "handleLoadErrorModalClose",
    value: function handleLoadErrorModalClose() {
      if (this.state.loadError) {
        this.state.loadError.dialogDismissed = true;
        this.setState({
          loadError: this.state.loadError
        });
      }
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var account = this.state.account;
      var context = this.props.context;
      var userInfo;
      if (context !== null && context !== void 0 && context.user && account) {
        userInfo = Object.assign({}, context.user, {
          "bss_account": account.accountGuid,
          "account_context": account.contextId
        });
      }
      return userInfo;
    }
  }, {
    key: "redirectOnePipelineTemplate",
    value: function redirectOnePipelineTemplate() {
      // For IBMers only, redirects to the IBM internal version of compliance templates
      var onePipelineUrls = {
        cdTemplate: "https://github.ibm.com/one-pipeline/compliance-cd-toolchain",
        ciTemplate: "https://github.ibm.com/one-pipeline/compliance-ci-toolchain",
        ciTemplateForIaC: "https://github.ibm.com/one-pipeline/iac-compliance-ci-toolchain",
        ccTemplate: "https://github.ibm.com/one-pipeline/compliance-cc-toolchain"
      };
      var currentUrl = window.location;
      var searchParams = new URLSearchParams(currentUrl.search);
      var repo = searchParams.get("repository");
      if (isComplianceIntegrationTemplate(repo)) {
        // CI template
        searchParams.set("repository", onePipelineUrls.ciTemplate);
        window.location.search = searchParams.toString();
      } else if (isComplianceIntegrationTemplateForIaC(repo)) {
        // CI template
        searchParams.set("repository", onePipelineUrls.ciTemplateForIaC);
        window.location.search = searchParams.toString();
      } else if (isComplianceDeploymentTemplate(repo)) {
        // CD template
        searchParams.set("repository", onePipelineUrls.cdTemplate);
        window.location.search = searchParams.toString();
      } else if (isContinuousComplianceTemplate(repo)) {
        // CC template
        searchParams.set("repository", onePipelineUrls.ccTemplate);
        window.location.search = searchParams.toString();
      }
    }
  }, {
    key: "renderCreator",
    value: function renderCreator() {
      var _this0 = this;
      return /*#__PURE__*/React.createElement("div", {
        id: "main-content",
        className: "deploy ibm-cloud-app"
      }, function () {
        if (_this0.state.loadError) {
          // Failed to load the template; give up
          if (!_this0.state.loadError.dialogDismissed) {
            var error = _this0.state.loadError;
            return /*#__PURE__*/React.createElement(ErrorSection, {
              key: "template-load-error",
              error: error,
              onModalClose: _this0.handleLoadErrorModalClose
            });
          } else {
            // note, notification not showing this extra info
            // from the dialog: error.details.description
            var _error = _this0.state.loadError;
            return /*#__PURE__*/React.createElement("div", {
              className: "deploy-load-error-notification"
            }, /*#__PURE__*/React.createElement(Notification, {
              kind: "error",
              title: _error.title || msgs.get('error.generic'),
              subtitle: _error.description || _error.message || _error
            }));
          }
        }
        var params = _this0.props.params;
        var wizard = _this0.state.capabilities && _this0.state.capabilities.getWizard();
        var templateMetadata = _this0.state.capabilities && _this0.state.capabilities.getTemplate();
        var templateName = templateMetadata && templateMetadata.name;
        var templateIcon = templateMetadata && templateMetadata.icon;
        var availableCapabilities = _this0.state.capabilities ? _this0.state.capabilities.types({
          excludeWizardForms: true
        }).sort().map(function (type) {
          return _this0.state.capabilities.map[type][0];
        }) : [];
        var phase = _this0.state.phase;
        var locale = _this0.context.locale;
        var tabsClass = "tabs".concat(phase !== Phase.READY ? " hidden" : "");
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeployHeader, {
          envId: _this0.props.context.envId,
          icon: templateIcon,
          locale: _this0.props.context.locale,
          phase: phase,
          title: templateName,
          params: params,
          wizardMode: false
        }), /*#__PURE__*/React.createElement("div", {
          className: "notification-section"
        }, _this0.renderNotifications(locale)), _this0.state.isHydrated &&
        /*#__PURE__*/
        // workaround for cloud-pal-community Tabs-related lack of SSR support
        React.createElement(Tabs, null, /*#__PURE__*/React.createElement(TabList, {
          className: tabsClass,
          "aria-label": msgs.get('tabs', locale)
        }, /*#__PURE__*/React.createElement(Tab, {
          id: "create-tab",
          className: "tab"
        }, msgs.get('create.tab', locale)), /*#__PURE__*/React.createElement(Tab, {
          id: "about-tab",
          className: "tab"
        }, msgs.get('about.tab', locale))), /*#__PURE__*/React.createElement(TabPanels, null, /*#__PURE__*/React.createElement(TabPanel, {
          id: "create-tab-tabpanel",
          className: "tabpanel"
        }, _this0.renderDeployPageContent()), /*#__PURE__*/React.createElement(TabPanel, {
          id: "about-tab-tabpanel",
          className: "tabpanel"
        }, /*#__PURE__*/React.createElement("div", {
          className: "about-tab-content"
        }, /*#__PURE__*/React.createElement(About, {
          availableCapabilities: availableCapabilities,
          displayMode: "tab",
          locale: _this0.props.context.locale,
          onClickGetStarted: function onClickGetStarted() {
            document.getElementById('create-tab').click();
          },
          phase: phase,
          showTools: true,
          templateMetadata: templateMetadata,
          wizard: wizard
        }))))));
      }());
    }
  }, {
    key: "renderWizard",
    value: function renderWizard() {
      var _this1 = this;
      var locale = this.context.locale;
      var params = this.props.params;
      var _this$state2 = this.state,
        capabilities = _this$state2.capabilities,
        isIBMer = _this$state2.isIBMer,
        loadError = _this$state2.loadError,
        phase = _this$state2.phase;
      var wizard = capabilities && capabilities.getWizard();
      var userDetails = this.getUserInfo();
      return /*#__PURE__*/React.createElement("div", {
        id: "main-content",
        className: "deploy ibm-cloud-app"
      }, function () {
        if (loadError) {
          // Failed to load the template; give up
          var error = loadError;
          return /*#__PURE__*/React.createElement(ErrorSection, {
            key: "template-load-error",
            error: error,
            onModalClose: Function.prototype /*noop*/
          });
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "wizard"
        }, function (_this1$props$params) {
          var templateMetadata = capabilities && capabilities.getTemplate();
          var templateIcon = templateMetadata && templateMetadata.icon;
          var templateName = templateMetadata && templateMetadata.name;
          var repo = (_this1$props$params = _this1.props.params) === null || _this1$props$params === void 0 ? void 0 : _this1$props$params.repository;
          var isCompliance = isComplianceTemplate(repo);
          var isPublic = isPublicTemplate(repo);
          return /*#__PURE__*/React.createElement(React.Fragment, null, /* Only show this banner to IBMers who are using public compliance templates */
          // Note, not actually showing the blue-to-purple withGradient fade,
          // but the yellow background has similar characteristics
          // in the button background-color handling.
          isCompliance && isIBMer && isPublic && /*#__PURE__*/React.createElement("div", {
            className: "internal-warning-banner",
            id: "internal-banner-container"
          }, /*#__PURE__*/React.createElement(Banner, {
            dismissible: true,
            withGradient: true
          }, /*#__PURE__*/React.createElement(WarningAlt, {
            className: "warning-icon"
          }, /*#__PURE__*/React.createElement("title", null, commonMsgs.get("warning", locale))), /*#__PURE__*/React.createElement(Markdown, {
            content: msgs.get("wizard.warning.internal.template", locale)
          }), /*#__PURE__*/React.createElement(Button, {
            size: "sm",
            onClick: _this1.redirectOnePipelineTemplate
          }, msgs.get("wizard.warning.internal.template.use", locale)))), /*#__PURE__*/React.createElement(DeployHeader, {
            envId: _this1.props.context.envId,
            handleDetailsClicked: _this1.handleDetailsClicked,
            icon: templateIcon,
            isComplianceTemplate: isComplianceTemplate(repo),
            isPublicTemplate: isPublicTemplate(repo),
            locale: _this1.props.context.locale,
            params: params,
            phase: phase,
            title: templateName,
            userInfo: userDetails,
            wizard: wizard,
            wizardMode: true
          }), _this1.renderNotifications(locale), _this1.renderDeployPageWizardContent());
        }());
      }());
    }
  }, {
    key: "renderNotifications",
    value: function renderNotifications(locale) {
      var warningTitle = msgs.get('warning.deprecatedRegionTitle', locale);
      var warningMsg = msgs.get('warning.deprecatedRegionMsg', [this.state.deprecationNotifDate, '\n\n'], locale);
      var templateData = this.state.capabilities && this.state.capabilities.getTopLevelData();
      var isLoading = this.state.phase != Phase.READY;
      if (templateData !== null && templateData !== void 0 && templateData.warningNotification) {
        if (templateData.warningNotification.bmHelperValidator) {
          return /*#__PURE__*/React.createElement("div", {
            className: "validator-warning-notification"
          }, !isLoading && this.state.showDeprecationNotif && /*#__PURE__*/React.createElement(Notification, {
            kind: "warning",
            format: "markdown",
            lowContrast: true,
            title: warningTitle,
            subtitle: warningMsg
          }), templateData.warningNotification.bmHelperValidator && /*#__PURE__*/React.createElement(Notification, {
            kind: "error",
            format: "markdown",
            lowContrast: true,
            title: msgs.get('warning.deprecatedValidatorTitle'),
            subtitle: msgs.get('warning.deprecatedValidatorMsg', [htmlUtil.replaceWithEntities(templateData.warningNotification.repository)])
          }));
        } else if (templateData.warningNotification.cloudFoundryTemplate) {
          return /*#__PURE__*/React.createElement("div", {
            className: "validator-warning-notification"
          }, !isLoading && this.state.showDeprecationNotif && /*#__PURE__*/React.createElement(Notification, {
            kind: "warning",
            format: "markdown",
            lowContrast: true,
            title: warningTitle,
            subtitle: warningMsg
          }), templateData.warningNotification.cloudFoundryTemplate && /*#__PURE__*/React.createElement(Notification, {
            kind: "error",
            format: "markdown",
            lowContrast: true,
            title: msgs.get('warning.cloudFoundryTemplateTitle'),
            subtitle: msgs.get('warning.cloudFoundryTemplateMsg', [htmlUtil.replaceWithEntities(templateData.warningNotification.repository)])
          }));
        }
      } else {
        return !isLoading && this.state.showDeprecationNotif && /*#__PURE__*/React.createElement("div", {
          className: "validator-warning-notification"
        }, /*#__PURE__*/React.createElement(Notification, {
          kind: "warning",
          format: "markdown",
          lowContrast: true,
          title: warningTitle,
          subtitle: warningMsg
        }));
      }
    }
  }, {
    key: "renderServiceWarningModal",
    value: function renderServiceWarningModal(accountRegion) {
      var missingServices = [];
      if (this.state.unresolved.length > 0) {
        for (var i = 0; i < this.state.unresolved.length; i++) {
          missingServices.push(/*#__PURE__*/React.createElement("li", null, "msgs.get(\"warning.missingService\", [this.state.unresolved[i]])"));
        }
      }
      modal.open(/*#__PURE__*/React.createElement(Modal, {
        id: "serviceUnavailable",
        className: "modal-service-warning",
        open: true,
        modalHeading: msgs.get("warning.serviceUnavailableTitle"),
        primaryButtonText: commonMsgs.get('close'),
        onRequestClose: modal.close,
        onRequestSubmit: modal.close
      }, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: msgs.get("warning.serviceUnavailableDesc", [accountRegion ? accountRegion.display_name : null])
        }
      }), /*#__PURE__*/React.createElement("ul", null, this.state.unresolved.map(function (cap) {
        return /*#__PURE__*/React.createElement("li", {
          key: cap,
          dangerouslySetInnerHTML: {
            __html: msgs.get("warning.missingService", [cap])
          }
        });
      }))));
    }
  }, {
    key: "renderNotSupportedWarningModal",
    value: function renderNotSupportedWarningModal() {
      var _this10 = this;
      modal.open(/*#__PURE__*/React.createElement(Modal, {
        id: "serviceNotSupported",
        className: "modal-service-warning",
        open: true,
        modalHeading: msgs.get("warning.serviceNotSupportedTitle"),
        primaryButtonText: commonMsgs.get('close'),
        onRequestClose: modal.close,
        onRequestSubmit: modal.close
      }, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: msgs.get("warning.serviceNotSupportedDesc")
        }
      }), /*#__PURE__*/React.createElement("ul", null, this.state.unsupported.map(function (capabilityId) {
        var capabilityName = capabilityId;
        if (_this10.state.capabilities && _this10.state.capabilities.getMetadata(capabilityId) && _this10.state.capabilities.getMetadata(capabilityId).displayName) {
          capabilityName = _this10.state.capabilities.getMetadata(capabilityId).displayName;
        }
        return /*#__PURE__*/React.createElement("li", {
          key: capabilityId,
          dangerouslySetInnerHTML: {
            __html: msgs.get("warning.notSupportedService", [capabilityName, capabilityId])
          }
        });
      }))));
    }
  }, {
    key: "getFSCloudDialogData",
    value: function getFSCloudDialogData() {
      var _this$props$context, _this$accountTraits;
      var fsCloudDialogData = {};
      if (!((_this$props$context = this.props.context) !== null && _this$props$context !== void 0 && _this$props$context.enableFSCloudDialog)) {
        fsCloudDialogData.showFSCloudDialog = false;
        return fsCloudDialogData;
      }
      var fsCloudEnabled = false;
      var isFSCompliant = this.checkFSCloudCompliant();
      // Under normal working conditions accountTraits will provide true/false for fs_ready
      // On rare circumstances it could be indeterminate. The instructions in this case are
      // to show the error form of the fsCloud dialog if there are also non fsCloud validated tools

      if (((_this$accountTraits = this.accountTraits) === null || _this$accountTraits === void 0 ? void 0 : _this$accountTraits.fs_ready) !== false) {
        fsCloudEnabled = true;
      }
      fsCloudDialogData.accountTraitsError = this.accountTraitsError;
      fsCloudDialogData.showFSCloudDialog = this.props.context.enableFSCloudDialog && !isFSCompliant && fsCloudEnabled;
      return fsCloudDialogData;
    }
  }, {
    key: "renderDeployPageContent",
    value: function renderDeployPageContent() {
      var templateMetadata = this.state.capabilities && this.state.capabilities.getTemplate();
      var userDetails = this.getUserInfo();
      var creationOverlay = this.state.phase === Phase.CREATING || this.state.phase === Phase.CREATED ? /*#__PURE__*/React.createElement(Loading, {
        withOverlay: true
      }) : null;
      var phase = this.state.phase;
      var fsCloudData = this.getFSCloudDialogData();
      return /*#__PURE__*/React.createElement("div", {
        className: "create-tab-content"
      }, creationOverlay, !this.state.allowedRegion && /*#__PURE__*/React.createElement(Notification, {
        kind: "error",
        title: msgs.get('error.allowedRegionTitle'),
        subtitle: msgs.get('error.allowedRegionMsg')
      }), /*#__PURE__*/React.createElement("div", {
        className: "deploy-page-content"
      }, /*#__PURE__*/React.createElement("section", {
        key: "main",
        className: "mainContent"
      }, /*#__PURE__*/React.createElement(AppDetailsSection, {
        allRegions: this.state.allRegions ? this.state.allRegions : null,
        capabilities: this.state.capabilities,
        catalogMap: this.state.catalogMap,
        unresolved: this.state.unresolved,
        error: this.state.createError,
        handleRGChange: this.handleComponentRGChange,
        handleClearRG: this.handleClearRG,
        enableRg: this.props.context.enableRg,
        handleRegionChange: this.handleComponentRegionChange,
        handleUpdateRefs: this.updateRefs,
        handleResolveRef: this.resolveRef,
        onModalClose: this.handleCreateErrorModalClose,
        onToolchainNameChange: this.setToolchainName,
        onValidatorEvent: this.handleValidatorEvent,
        onDetectSecretReference: this.handleDetectSecretReference,
        isCapabilityHasSecretRef: this.isCapabilityHasSecretRef,
        phase: this.state.phase,
        region: this.state.region ? this.state.region : null,
        toolchainName: this.getToolchainName(),
        tracker: this.tracker,
        userInfo: userDetails,
        resourceGroup: this.state.resourceGroup,
        tcRegions: this.state.regionsConf,
        allowedRegion: this.state.allowedRegion,
        account: this.state.account,
        context: this.props.context,
        showDynamicPicker: templateMetadata && templateMetadata.dyml && templateMetadata.dyml.hasSourceProvider,
        showPipelineType: templateMetadata && templateMetadata.dyml && templateMetadata.dyml.hasTektonPipeline,
        createClicked: this.state.createClicked,
        updateFocus: this.updateFocus,
        handleServiceClick: this.handleServiceClick,
        expandedServiceType: this.state.expandedServiceType,
        handleScrolled: this.handleScrolled,
        shouldFocus: this.state.shouldFocus,
        isDeployButtonEnabled: this.isDeployButtonEnabled,
        canCreateToolchain: this.canCreateToolchain,
        handleWizardWelcomeValid: this.handleWizardWelcomeValid,
        setNameValidity: this.setNameValidity,
        getCapabilityCount: this.getCapabilityCount,
        setAuthDone: this.setAuthDone,
        overrideScroll: this.state.overrideScroll,
        handleTabClick: this.handleTabClick,
        tabIndex: this.state.tabIndex,
        enableCreateButton: this.state.enableCreateButton,
        handleDeployClicked: this.handleDeployClicked,
        wizardMode: false,
        params: this.props.params,
        reloadTemplate: this.reloadTemplate,
        integrationsAuthDone: this.state.integrationsAuthDone,
        setDirtyFlag: this.setDirtyFlag,
        enableToolchainCreateButton: this.state.enableToolchainCreateButton,
        fsCloudDialogData: fsCloudData
      }))), /*#__PURE__*/React.createElement(DeployButtons, {
        allowedRegion: this.state.allowedRegion,
        enableCreateButton: this.state.enableCreateButton,
        envId: this.props.context.envId,
        handleDeployClicked: this.handleDeployClicked,
        locale: this.props.context.locale,
        params: this.props.params,
        phase: phase,
        showCancel: true,
        showCreate: true,
        showNext: false,
        showPrevious: false,
        enableToolchainCreateButton: this.state.enableToolchainCreateButton,
        fsCloudDialogData: fsCloudData,
        wizardMode: false
      }));
    }
  }, {
    key: "renderDeployPageWizardContent",
    value: function renderDeployPageWizardContent() {
      var _this11 = this;
      var templateMetadata = this.state.capabilities && this.state.capabilities.getTemplate();
      var userDetails = this.getUserInfo();
      var availableCapabilities = this.state.capabilities ? this.state.capabilities.types({
        excludeWizardForms: true
      }).sort().map(function (type) {
        return _this11.state.capabilities.map[type][0];
      }) : [];
      var phase = this.state.phase;
      var creationOverlay = phase === Phase.CREATING || phase === Phase.CREATED ? /*#__PURE__*/React.createElement(Loading, {
        withOverlay: true
      }) : null;
      var fsCloudData = this.getFSCloudDialogData();
      return /*#__PURE__*/React.createElement(React.Fragment, null, creationOverlay, userDetails && /*#__PURE__*/React.createElement(WizardToolsPanel, {
        availableCapabilities: availableCapabilities,
        baseName: this.props.params.baseName,
        handleCancel: this.handleDetailsCancel,
        locale: this.props.context.locale,
        phase: phase,
        show: this.state.showDetails,
        showTools: true,
        templateMetadata: templateMetadata
      }), /*#__PURE__*/React.createElement("div", {
        className: "deploy-page-content"
      }, /*#__PURE__*/React.createElement("section", {
        key: "main",
        className: "mainContent"
      }, /*#__PURE__*/React.createElement(AppDetailsSection, {
        allRegions: this.state.allRegions ? this.state.allRegions : null,
        capabilities: this.state.capabilities,
        catalogMap: this.state.catalogMap,
        unresolved: this.state.unresolved,
        error: this.state.createError,
        handleRGChange: this.handleComponentRGChange,
        handleClearRG: this.handleClearRG,
        enableRg: this.props.context.enableRg,
        handleRegionChange: this.handleComponentRegionChange,
        handleUpdateRefs: this.updateRefs,
        handleResolveRef: this.resolveRef,
        onModalClose: this.handleCreateErrorModalClose,
        onToolchainNameChange: this.setToolchainName,
        onValidatorEvent: this.handleValidatorEvent,
        onDetectSecretReference: this.handleDetectSecretReference,
        isCapabilityHasSecretRef: this.isCapabilityHasSecretRef,
        phase: this.state.phase,
        region: this.state.region ? this.state.region : null,
        toolchainName: this.getToolchainName(),
        tracker: this.tracker,
        userInfo: userDetails,
        resourceGroup: this.state.resourceGroup,
        tcRegions: this.state.regionsConf,
        allowedRegion: this.state.allowedRegion,
        account: this.state.account,
        context: this.props.context,
        showDynamicPicker: templateMetadata && templateMetadata.dyml && templateMetadata.dyml.hasSourceProvider,
        showPipelineType: templateMetadata && templateMetadata.dyml && templateMetadata.dyml.hasTektonPipeline,
        createClicked: this.state.createClicked,
        updateFocus: this.updateFocus,
        handleServiceClick: this.handleServiceClick,
        expandedServiceType: this.state.expandedServiceType,
        handleScrolled: this.handleScrolled,
        shouldFocus: this.state.shouldFocus,
        isDeployButtonEnabled: this.isDeployButtonEnabled,
        canCreateToolchain: this.canCreateToolchain,
        setNameValidity: this.setNameValidity,
        handleWizardWelcomeValid: this.handleWizardWelcomeValid,
        getCapabilityCount: this.getCapabilityCount,
        setAuthDone: this.setAuthDone,
        overrideScroll: this.state.overrideScroll,
        handleTabClick: this.handleTabClick,
        tabIndex: this.state.tabIndex,
        template: this.state.template,
        integrationsAuthDone: this.state.integrationsAuthDone,
        isWizardWelcomeValid: this.state.isValid.welcomeStep,
        enableCreateButton: this.state.enableCreateButton,
        handleDeployClicked: this.handleDeployClicked,
        params: this.props.params,
        reloadTemplate: this.reloadTemplate,
        setDirtyFlag: this.setDirtyFlag,
        wizardCompletedStep: this.state.wizardCompletedStep,
        setWizardCompletedStep: this.setWizardCompletedStep,
        wizardGitAccept: this.state.isValid.gitAccept,
        handleGitAcceptValid: this.handleGitAcceptValid,
        enableToolchainCreateButton: this.state.enableToolchainCreateButton,
        fsCloudDialogData: fsCloudData,
        wizardMode: true
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var content = this.isWizardModeEnabled() ? this.renderWizard() : this.renderCreator();
      var appContextValue = {
        account: this.state.account,
        cdnDomain: this.props.context.cdnDomain,
        enableFSCloudDialog: this.props.context.enableFSCloudDialog,
        envId: this.props.context.envId,
        locale: this.props.context.locale,
        readOnly: false
      };
      if (this.state.isMounted) {
        return (
          /*#__PURE__*/
          // the provider is not CSP-safe for server-side rendering at this time
          // only render it once mounted in the browser
          React.createElement(AppContext.Provider, {
            value: appContextValue
          }, /*#__PURE__*/React.createElement(CpcProvider, null, content))
        );
      }
      return /*#__PURE__*/React.createElement(AppContext.Provider, {
        value: appContextValue
      }, content);
    }
  }]);
}(React.Component);
export { Deploy as default };
function makeGoodError(err) {
  var error = {
    cause: err,
    description: "",
    title: ""
  };
  if (err) {
    error.description = err.description || err.message || "";
    error.title = err.title || "";
    error.details = err.details;
  }
  return error;
}

// @returns UTC timestamp in format YYYYMMddHHmmssSSS
function toTimestamp(date) {
  return date.getUTCFullYear() + ("0" + (1 + date.getUTCMonth())).slice(-2) + ("0" + date.getUTCDate()).slice(-2) + ("0" + date.getUTCHours()).slice(-2) + ("0" + date.getUTCMinutes()).slice(-2) + ("0" + date.getUTCSeconds()).slice(-2) + ("00" + date.getUTCMilliseconds()).slice(-3);
}
function getInitialToolchainName(capabilities) {
  var toolchain = capabilities.getToolchain();
  if (toolchain && typeof toolchain.name === "string") {
    return toolchain.name;
  }
  return ""; // Should never happen
}

// hydrate component on client
client && pageInitializer.init(Deploy);